import React, { useEffect, useState, useRef, useContext } from 'react';
import { Toast } from 'primereact/toast';
import Form from 'react-bootstrap/Form';
import './notification.css'
import { BreadCrumb } from 'primereact/breadcrumb';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// import MapIcon from '../../assets/icons/map.svg';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import MapComponent from '../MapComponent';
import { getNotification } from '../../utils/api';
import moment from 'jalali-moment';
import Loadr from '../loader/loader';
import LoaderPage from '../loader/dotloader';
import { Accordion } from 'react-bootstrap'
import useToastNotification from '../../hooks/useToastNotification';


function Profile() { // Receive onProfileLoad as a prop
  const [loading, setLoading] = useState(false);
  const [notifList, setNotifList] = useState([])


  const fetchNotif = async () => {
    try {
      let res = await getNotification(JSON.parse(localStorage.getItem('userInfo')).si)
      if (res.status == 200) {
        setNotifList(res.data)
        console.log(res.data)
      } else {
        let error = {
          title: 'اخطار',
          text: response.data.restp,
        };
        showError(error);
      }
    } catch (error) {

      showError('خطا در برقرای ارتباط ...');
    }
  }

  useEffect(() => {
    fetchNotif()
  }, [])



  return (
    <>
      {loading && <LoaderPage isLoading={loading} />}

      <div className='profile-card'>
        {
          notifList.length > 0 ? (
            <>
              {
                notifList.map((item, index) => ( 
                  <div className='notif-card mt-2' key={index}>
                    <div className='d-flex align-items-center justify-content-between gap-4'>
                      <h6 className='text-base font-medium text-right'>{item.Tp}</h6>
                      <div className='notif-status' style={{ backgroundColor: '#E0EBD3' }}>
                        مشاهده شده
                      </div>
                    </div>
                    <div className='w-100 text-left mt-4 d-flex justify-content-end'>
                      <button className='btn btn-primary'>رفتن به صفحه مربوطه</button>

                    </div>


                  </div>
                ))
              }
            </>
          ) : (
            <>
              در حال حاضر هیچ پیغامی ندارید.
            </>
          )
        }

      </div>
    </>
  );
}

export default Profile;
